import markReadOnTableViewChange from 'owa-mail-actions/lib/table-loading/markReadOnTableViewChange';
import { createLazyOrchestrator } from 'owa-bundling';
import tryPerformRowAutoMarkAsRead from '../helpers/tryPerformRowAutoMarkAsRead';
import { isReadingPanePositionOff } from 'owa-mail-layout';
import { getViewFilterForTable } from 'owa-mail-list-store';

// Orchestrators for marking current rows as read when the table view changes
export const markReadOnTableViewChangeOrchestrator = createLazyOrchestrator(
    markReadOnTableViewChange,
    'markReadOnTableViewChangeClone',
    actionMessage => {
        const { oldSelectedRowKeys, oldTableView, newTableView } = actionMessage;

        // Do nothing when:
        // 1) In SLV
        // 2) More than one row is selected
        // 3) Moving to unread filter
        if (
            isReadingPanePositionOff() ||
            oldSelectedRowKeys.length !== 1 ||
            getViewFilterForTable(newTableView) === 'Unread'
        ) {
            return;
        }

        tryPerformRowAutoMarkAsRead(oldSelectedRowKeys[0], oldTableView);
    }
);
